import Vue from 'vue';
import Vuex from 'vuex';

import application from './application';
import category from './category';
import location from './location';
import menu from './menu';
import order from './order';
import user from './user';
import customer from './customer';

Vue.use(Vuex);

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

export default function (/* { ssrContext } */) {
  return new Vuex.Store({
    modules: {
      application,
      category,
      location,
      menu,
      order,
      user,
      customer,
    },

    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: process.env.DEV,
  });
}
